
import React, { Component } from "react";
import Loader from "../../Loader/Loader";
import TimeSaved from "./sections/TimeSaved";
import BottomButtons from './sections/BottomButtons';
import CityComparison from "./sections/CityComparison";
import AnimatedNumber from "react-animated-number";
import CompareButtons from "./sections/CompareButtons";
import { Link, Element } from "react-scroll";
import classnames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons";

import { connect } from "react-redux";
import styles from "./Calculator.scss";

import axios from "axios";
import {
	updateVisitor,
	setUserInfo
} from "../../../actions/DataCol/userdataAction";
const bodyScrollLock = require('body-scroll-lock');
const disableBodyScroll = bodyScrollLock.disableBodyScroll;

class Calculator extends Component {
	constructor(props) {
		super(props);
		this.state = {
			city_data: undefined,
			kingstonData: undefined,
			competitor_data: undefined,
			kingston_data: undefined,

			selectedCity: undefined,
			selectedCityData: undefined,
			initialSalary: 50000,
			selectedSalary: undefined,
			comparableSalary: undefined,

			initialCommute: undefined,
			selectedCommute: undefined,
			comparableCommute: undefined,
			salaryPercentage: undefined,

			children: undefined,
			displayResults: false,
			home: undefined,
		};
	}

	componentWillMount() {
		const targetElement = document.querySelector("display");
		if (window.innerWidth > 575){
			disableBodyScroll(targetElement);
		}
		axios
			.get("/api/cityData/getalldata")
			.then(res => {
				var kingstonData = undefined;
				res.data.map(city => {
					if (city.name === "Kingston") {
						kingstonData = city;
					}
					// Holder to avoid warning in console
					return city;
				});
				this.setState({
					city_data: res.data,
					kingstonData: kingstonData
				});
			})
			.catch(e => console.log(e));
	}

	setCommuteInfo = () => {
			console.log("Selected Commute", this.state.selectedCommute)
			this.compareCommute();
	}

	setCityInfo = city => {
		this.setState({
			selectedCity: city.name,
			selectedCityData: city,

			kingston_data: [
				this.state.kingstonData.water,
				this.state.kingstonData.energy,
				this.state.kingstonData.heat,
				this.state.kingstonData.groceries,
			],
			competitor_data: [
				city.water,
				city.energy,
				city.heat,
				city.groceries,
			]
		});
	};

	compareCommute = () => {
		let trans = this.state.selectedCommute;
		let cityCommute = this.state.initialCommute;
		let kingstonCommute = this.state.kingstonData.transportation[trans];
		let selectedCityCommuteMonth = 2 * cityCommute * 20;
		let kingstonCommuteMonth = 2 * kingstonCommute * 20;
		let comparableCommute =
			(selectedCityCommuteMonth - kingstonCommuteMonth) / 60;
		comparableCommute = Math.trunc(comparableCommute);

		this.setState({
			comparableCommute: comparableCommute
		});
	};

	compareSalary = () => {
		if (this.state.home === "rent") {
			this.state.kingston_data.push(this.state.kingstonData.rent);
			this.state.competitor_data.push(this.state.selectedCityData.rent);
		}
		if (this.state.home === "own") {
			this.state.kingston_data.push(
				this.state.kingstonData.property_taxes
			);
			this.state.competitor_data.push(
				this.state.selectedCityData.property_taxes
			);

			this.state.kingston_data.push(
				Math.round((this.state.kingstonData.own / 25) * 1.035)
			);
			this.state.competitor_data.push(
				Math.round((this.state.selectedCityData.own / 25) * 1.035)
			);
		}

		if (this.state.children === true) {
			this.state.kingston_data.push(this.state.kingstonData.child_care);
			this.state.competitor_data.push(this.state.selectedCityData.child_care);
		}

		if (this.state.selectedCommute === 'public') {
			this.state.kingston_data.push(this.state.kingstonData.public_transit);
			this.state.competitor_data.push(this.state.selectedCityData.public_transit);

		} else if (this.state.selectedCommute === 'car') {
			this.state.kingston_data.push(this.state.kingstonData.insurance);
			this.state.kingston_data.push(this.state.kingstonData.gasoline);

			this.state.competitor_data.push(this.state.selectedCityData.insurance);
			this.state.competitor_data.push(this.state.selectedCityData.gasoline);
		}


		let kingstonCOI = this.state.kingston_data.reduce((a, b) => a + b, 0);
		let cityCOI = this.state.competitor_data.reduce((a, b) => a + b, 0);
		let initialSalary = parseInt(this.state.initialSalary, 10);
		let comparableSalary =
			initialSalary + ((kingstonCOI - cityCOI) / cityCOI) * initialSalary;
		let salaryPercentage = Math.round(
			(this.state.initialSalary / comparableSalary) * 100
		);

		this.setState({
			selectedSalary: this.state.initialSalary,
			comparableSalary: comparableSalary,
			salaryPercentage: salaryPercentage
		});
	};

	handleChange = event => {
		this.setState({
			[event.target.name]: event.target.value,
		 });
	};

	// Checks if the user has selected a city
	checkCity = () => {
		let salaryLimit = 9000000;
		let commuteLimit = 24;
		if ((this.state.selectedCityData !== undefined) && (this.state.initialSalary <= salaryLimit) && (this.state.initialSalary >= 0)
		&& ((this.state.initialCommute <= commuteLimit*60 && this.state.initialCommute >= 0) || this.state.initialCommute === undefined)) {
			this.compareSalary();
			this.setState(
				{
					displayResults: true
				},
				() => {
					if(this.props.user !== undefined){
						var user = {...this.props.user};
						user.calculator = {
							city: this.state.selectedCity,
							salary: this.state.selectedSalary,
							home: this.state.home,
							commute: this.state.initialCommute,
							mode: this.state.selectedCommute
						};
						updateVisitor(user);
						this.props.setUserInfo(user);
					}
				}
			);
		} else if (this.state.selectedCityData === undefined){
			this.setState({
				warning: "You must select a city to compare!"
			});
		} else if(0 > this.state.initialSalary || this.state.initialSalary > salaryLimit){
			this.setState({
				warning: "Your salary must be between 0 and $9,000,000!"
			});
		} else if(0 > this.state.initialCommute || this.state.initialCommute > commuteLimit*60){
			this.setState({
				warning: "Your commute time must be between 0 and 1,440!"
			});
		}
	};

	deselectCity = () => {
		this.setState({
			selectedCity: undefined,
			selectedCityData: undefined,
			displayResults: false,
			warning: undefined,
			// selectedCommute: undefined,
			// home: undefined,
			// initialCommute: 45,
			// selectedCommute: undefined,
		});
	};

	sortCitiesAlphabetically = city_data => {
		let visible = [];
		city_data.forEach(city => {
			if (city.hidden === false) {
				visible.push(city);
			}
		});
		return visible.sort((a, b) =>
			a.name > b.name ? 1 : b.name > a.name ? -1 : 0
		);
	};

	handleCityChange = event => {
		this.setState({ selectedCity: JSON.parse(event.target.value) }, () =>
			this.setCityInfo(this.state.selectedCity)
		);
	};


	getScrollLink = (elementName, downOrUp) => {
		if (window.innerWidth <= 575){
			return (null)
		}
		return (
			<Link
				to={elementName}
				smooth={true}
				duration={500}
			>
				<div className={styles.scrollArrow}>
					<FontAwesomeIcon
						icon={(downOrUp === "down")? faAngleDown : faAngleUp}
						size="3x"
					/>
				</div>
			</Link>
		)
	}

	render() {
		if (!this.state.city_data) {
			return <Loader />;
		}
		return (

			<Element name="display" id="display">
				<div className={styles.calculator} style={{overflow:"auto","WebkitOverflowScrolling":"touch"}}>
					{!this.state.displayResults && (
						<div>
							<div className="container">
								<div className="form-group">
									<label htmlFor="cityselect">
										I'm Moving From: <span className={styles.error}>*</span>
									</label>
									<select
										className="form-control"
										id="cityselect"
										defaultValue={"DEFAULT"}
										onChange={this.handleCityChange}
									>
										<option disabled value='DEFAULT'>
											-- Select a City --
										</option>
										{this.sortCitiesAlphabetically(
											this.state.city_data
										).map((city, i) => (
											<option
												key={i}
												value={JSON.stringify(city)}
											>
												{city.value}
											</option>
										))}
									</select>
								</div>

								<div className="form-group">
									<label htmlFor="salaryselect">
										My Current Salary ($ CAN){" "}<span className={styles.error}>*</span>
									</label>
									<input
										className="form-control"
										id="salaryselect"
										defaultValue={this.state.initialSalary}
										value={this.state.selectedSalary}
										onChange={this.handleChange}
										name="initialSalary"
										type="number"
										step="5000"
										min="0"
										max="1000000"
									/>
								</div>
								{ this.salaryError &&
									<span className={styles.error}>
										{this.state.salaryError}
									</span>

								}

								<div className="form-group">
									<label> I'm looking for a home to: </label>
									&emsp;
									<label>
										<input
											type="checkbox"
											checked={this.state.home === "own"}
											onChange={() => {
												this.setState({
													home: (this.state.home === "own" ? undefined : "own")
												});
											}}
										/>
										<span className={styles.label}>
											Own
										</span>
									</label>
									<label>
										<input
											type="checkbox"
											checked={this.state.home === "rent"}
											onChange={() => {
												this.setState({
													home: (this.state.home === "rent" ? undefined : "rent")
												});
											}}
										/>
										<span className={styles.label}>
											Rent
										</span>
									</label>
								</div>
								<div className="form-group">
									<label> Do you have children that require child care?
									&emsp;
										<input
											type="checkbox"
											checked={(this.state.children === undefined) ? false : this.state.children}
											onChange={() => this.setState({
												children: (this.state.children === true ? undefined : true)
											})}
										/>
										<span className={styles.label}>
											Yes
										</span>
									</label>
									<label>
										<input
											type="checkbox"
											checked={(this.state.children === undefined) ? false : !this.state.children}
											onChange={() => this.setState({
												children: (this.state.children === false ? undefined : false)
											})}
										/>
										<span className={styles.label}>
											No{" "}
										</span>
									</label>
								</div>
								<div className="form-group">
									<label>
										{" "}
										My Current One-Way Commute Time (min){" "}
									</label>
									<input
										className="form-control"
										type="number"
										step="5"
										value={this.state.initialCommute}
										onBlur={this.compareCommute}
										onChange={this.handleChange}
										name="initialCommute"
										min={0}
									/>
								</div>

								<div className="form-group">
									<label> I Commute To Work By: </label>
									&emsp;
									<label>
										<input
											type="checkbox"
											checked={this.state.selectedCommute === "car"}
											onChange={() => this.setState({
												selectedCommute: "car"
											}, () => this.setCommuteInfo())}
										/>
										<span className={styles.label}>
											Driving
										</span>
									</label>
									<label>
										<input
											type="checkbox"
											checked={this.state.selectedCommute === "public"}
											onChange={() => this.setState({
												selectedCommute: "public"
											}, () => this.setCommuteInfo())}
										/>
										<span className={styles.label}>
											Public Transit{" "}
										</span>
									</label>
									<label>
										<input
											type="checkbox"
											checked={this.state.selectedCommute === "active"}
											onChange={() => this.setState({
												selectedCommute: "active"
											}, () => this.setCommuteInfo())}
										/>
										<span className={styles.label}>
											Biking or Walking{" "}
										</span>
									</label>
								</div>

								{/*  */}
								<div style={{ textAlign: "center" }}>

										<button
											// className={styles.button}
											type="button"
											className="btn btn-light"
											onClick={this.checkCity}
										>
											See My Results!
										</button><br/>
										<span className={styles.error}>*</span> Required field
								</div>
								<p className={styles.center}>
									<span className={styles.error}>
										{this.state.warning}
									</span>
								</p>
							</div>
						</div>
					)}

					{this.state.displayResults && (
						<div>
							<div className={styles.displayRes}>
								{this.state.salaryPercentage - 100 > 0 && (
									<h2>
										Your salary will go{" "}
										<strong className={styles.highlight}>
											{this.state.salaryPercentage - 100}%
											further!
										</strong>
									</h2>
								)}
								{this.state.salaryPercentage - 100 < 0 && window.innerWidth < 376 && window.innerHeight > 794 && (
									<div className={styles.summary}>
										<h2 className={styles.notFar}>
											Your salary doesn't go as
											far. Sometimes you get what you pay for.
											<br />
										</h2>
									</div>
								)}
								{this.state.salaryPercentage - 100 < 0 && !(window.innerWidth < 376 && window.innerHeight > 794) && (
									<div className={styles.summary}>
										<h2 className={styles.notFar}>
											Your salary doesn't go as
											far. Sometimes you get what you pay for.
											<br />
										</h2>
										<h3>
											<strong className={styles.justification}>
												Family friendly neighbourhoods, a
												bustling downtown, and extensive
												waterfront access await you!
											</strong>
										</h3>
									</div>
								)}
								<h3>
									That's like earning
								</h3>
								<AnimatedNumber
									value={Math.round(
										this.state.initialSalary *
											(this.state.salaryPercentage / 100)
									)}
									style={{
										transition: "0.8s ease-out",
										color: "#007D99",
										fontSize: "9vw",
										transitionProperty:
											"background-color, color, opacity"
									}}
									frameStyle={perc =>
										perc === 100 ? {} : {}
									}
									duration={1000}
									initialValue={this.state.initialSalary}
									formatValue={n => `$${n.toLocaleString()}`}
									stepPrecision={0}
								/>
								<h3>where you live now!</h3>
								{this.state.comparableCommute > 0 && window.innerWidth > 575 && (
									<h2 className={styles.frontPageTime}>
										 You will also save{" "}
										<strong className={styles.highlight}>
											{this.state.comparableCommute}
											{" "}hours a month{" "}
										</strong>
										 because your commute is shorter in Kingston!
									</h2>)}
								{window.innerWidth > 575 && (
								<Link
									activeclassname="active"
									to="compare"
									spy={true}
									smooth={true}
									offset={0}
									duration={500}
									onSetActive={this.handleSetActive}
								>
									<div className={styles.arrow}>
										<FontAwesomeIcon
											icon={faAngleDown}
											size="7x"
										/>
									</div>
									<h3>Click for more details...</h3>
								</Link>
							)}
							</div>
							<div className={classnames("row", this.state.salaryPercentage - 100 < 0 ? styles.rowHeight_o : styles.rowHeight)}>
				        <div className={classnames("col-lg-12 my-3", styles.buttonHeight)}>
				          <Link to="page1" duration={500} spy={true} smooth={true}><button type="button" style={{marginRight: '1vw'}} className="btn btn-info btn-lg col-xl-2 col-sm-4 col-xs-7 col-lg-2 col-7"><CompareButtons className = {styles.chevron} ButtonkingstonData={((this.state.kingstonData.own /25)*1.035)} selectedCityData={(this.state.selectedCityData.own/25)*1.035} transportFlag={0}/><span className={styles.arrowButton}> House </span></button></Link>
				          <Link to="page1" duration={500} spy={true} smooth={true}><button type="button" style={{margin: '1vw'}} className="btn btn-info btn-lg col-xl-2 col-sm-4 col-xs-7 col-lg-2 col-7"><CompareButtons className = {styles.chevron} kingstonData={this.state.kingstonData.energy+this.state.kingstonData.water+this.state.kingstonData.heat} selectedCityData={this.state.selectedCityData.energy+this.state.selectedCityData.water+this.state.selectedCityData.heat} transportFlag={0}/><span className={styles.arrowButton}> Utilities </span></button></Link>
				          <Link to="page2" duration={500} spy={true} smooth={true}><button type="button" style={{margin: '1vw'}} className="btn btn-info btn-lg col-xl-2 col-lg-2 col-xs-7 col-sm-4 col-7"><CompareButtons className = {styles.chevron} kingstonData={this.state.kingstonData.groceries} selectedCityData={this.state.selectedCityData.groceries} transportFlag={0}/><span className={styles.arrowButton}> Groceries </span></button>
				          <button type="button" style={{margin: '1vw'}} className="btn btn-info btn-lg col-xl-2 col-lg-2 col-sm-4 col-xs-7 col-7"><CompareButtons className = {styles.chevron} kingstonData={this.state.kingstonData.public_transit} selectedCityData={this.state.selectedCityData.public_transit}/><span className={styles.arrowButton}> Transportation </span></button></Link>
				          <Link to="page2" duration={500} spy={true} smooth={true}><button type="button" style={{marginLeft: '1vw'}} className="btn btn-info btn-lg col-xl-2 col-lg-2 col-sm-4 col-xs-7 col-7"><CompareButtons className = {styles.chevron} kingstonData={this.state.kingstonData.child_care} selectedCityData={this.state.selectedCityData.child_care} transportFlag={0}/><span className={styles.arrowButton}> Child Care </span></button></Link>
				        </div>
				      </div>
							<div className={styles.bezel}>
							</div>

							<Element name="compare" />
							<CityComparison
								showTimeSavedArrow={
									this.state.selectedCommute !== undefined
									&& this.state.comparableCommute > 0}
								showAnyArrows={window.innerWidth > 575}
								getScrollLink={this.getScrollLink}
								selectedCityData={this.state.selectedCityData}
								kingstonData={this.state.kingstonData}
								compareCommute={this.state.comparableCommute}
								homeOption={this.state.home}
							/>
							{this.state.selectedCommute !== undefined &&
								this.state.comparableCommute > 0 && (
									<TimeSaved
										commute={this.state.comparableCommute}
										salary={this.state.initialSalary}
									/>
								)}
							<BottomButtons deselectCity={this.deselectCity} />
							<div className={styles.sources}>
								 <span>
									These results are powered by data collected
									from {" "}
									<a
										target="_blank"
										rel="noopener noreferrer"
										href="https://www.environicsanalytics.com/en-ca/"
									>
										Environics Analytics
									</a>
									,{" "}
									<a
										target="_blank"
										rel="noopener noreferrer"
										href="https://www.cmhc-schl.gc.ca/"
									>
										CMHC: Canada Mortgage and Housing
										Corporation
									</a>
									,{" "}
									<a
										target="_blank"
										rel="noopener noreferrer"
										href="https://www.oeb.ca/"
									>
										OEB: Ontario Energy Board
									</a>
									, and{" "}
									<a
										target="_blank"
										rel="noopener noreferrer"
										href="http://www2.nrcan.gc.ca/eneene/sources/pripri/price_map_e.cfm#allprices"
									>
										NRCAN: Natural Resources Canada
									</a>
									.
									<br />
									Mortgage is calculated based off an annual
									payment over 25 years with a 3.5% interest
									rate.
								</span>
							</div>
						</div>
					)}
				</div>
			</Element>
		);
	}
}
function mapStateToProps(state) {
	return {
		user: state.user.user
	};
}

const actions = {
	setUserInfo
};

export default connect(
	mapStateToProps,
	actions
)(Calculator);



// WEBPACK FOOTER //
// ./src/components/pages/Calculator/Calculator.js